import React from 'react';
import { Flame, AlertTriangle } from 'lucide-react';
export function UrgencyBanner() {
  return <section className="py-6 px-4 bg-gradient-to-br from-red-900 via-red-800 to-orange-900" data-id="element-224">
      <div className="max-w-2xl mx-auto" data-id="element-225">
        {/* Title */}
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-226">
          <Flame className="w-6 h-6 text-yellow-400" data-id="element-227" />
          <h3 className="font-heading text-xl md:text-2xl font-bold text-white uppercase tracking-wide" data-id="element-228">
            PROMOCIÓN POR TIEMPO LIMITADO
          </h3>
          <Flame className="w-6 h-6 text-yellow-400" data-id="element-229" />
        </div>

        {/* Progress bar section */}
        <div className="bg-black/20 rounded-xl p-4 mb-4" data-id="element-230">
          <div className="flex items-center justify-between mb-3" data-id="element-231">
            <div className="flex items-center gap-2 text-yellow-200 font-body text-sm font-medium" data-id="element-232">
              <AlertTriangle className="w-4 h-4" data-id="element-233" />
              <span data-id="element-234">Cupos disponibles agotándose</span>
            </div>
            <span className="bg-yellow-400/20 text-yellow-300 text-xs font-heading font-bold px-3 py-1 rounded-full border border-yellow-400/30" data-id="element-235">
              80% tomados
            </span>
          </div>

          {/* Progress bar */}
          <div className="w-full h-3 bg-black/30 rounded-full overflow-hidden" data-id="element-236">
            <div className="h-full rounded-full bg-gradient-to-r from-yellow-400 via-orange-400 to-red-500 relative" style={{
            width: '80%'
          }} data-id="element-237">
              <div className="absolute inset-0 bg-white/20 animate-pulse rounded-full" data-id="element-238"></div>
            </div>
          </div>
        </div>

        {/* Urgency text */}
        <p className="text-center text-red-100/80 font-body text-sm md:text-base italic leading-relaxed" data-id="element-239">
          Últimos cupos a precio promocional — una vez agotados, vuelve al
          precio original.
        </p>
      </div>
    </section>;
}